var _path, _rect, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAdderUpHover(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 15,
    viewBox: "0 0 40 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 3L3 0V15H0V3Z",
    fill: "#7FFAE2"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 15,
    transform: "translate(3)",
    fill: "#7FFAE2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 10L20 5L27 10",
    stroke: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40 3L37 0V15H40V3Z",
    fill: "#7FFAE2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdderUpHover);
export default __webpack_public_path__ + "static/media/adder-up-hover.183491358f9752af3cdda9f6a0b25c54.svg";
export { ForwardRef as ReactComponent };